<div class="form-group">
  <label class="control-label">
    <span class="form-label">{{ label }}</span>
    <div class="input-wrapper">
      <i
        class="input-icon input-icon--right rx-add"
        *ngIf="!disabled && !hidePlusMinusIcons"
        (click)="add()"
        data-qa="rx-plus-icon"
      ></i>
      <i
        class="input-icon input-icon--left rx-minus"
        *ngIf="!disabled && !hidePlusMinusIcons"
        (click)="subtract()"
        data-qa="rx-minus-icon"
      ></i>
      <input
        type="number"
        class="form-control form-control--right-padding"
        [(ngModel)]="value"
        [disabled]="disabled"
        [min]="min"
        [max]="max"
        (keyup)="checkMinimum()"
        (blur)="onInputBlur()"
      />
    </div>
  </label>

  <ng-content select="[rx-help]"></ng-content>
  <ng-content select="[rx-error]"></ng-content>

  <div rx-error *ngIf="error" class="rx-error">{{ error }}</div>
  <div rx-help *ngIf="help" class="rx-help">{{ help }}</div>
</div>
